export enum DropState {
    None,
    Before,
    Inner,
    After
}